import NoOrg from 'src/features/auth/components/NoOrg';

export default function NoOrgPage() {
  const handleSupport = () => {
    window.open('https://support.tekst.com');
  };
  return <NoOrg redirectUrl="/plugins/outlook/login" className="w-full" handleSupport={handleSupport} />;
}
